export default {
  form: 'data-comp-form-controller',
  formFieldset: 'data-comp-form-fieldset',
  formField: 'data-comp-form-field',
  formRoute: 'data-comp-form-route',
  formState: 'data-comp-form-state',
  submitButton: 'data-comp-form-submit-button',
};
